import { getSettingList, updateTruthValue, updateState } from '@/api/setting'

const setting = {
  state: {
    total: 0,
    rows: [],
    row: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    }
  },
  actions: {
    // 获取配置列表
    GetSettingList({ commit }) {
      return new Promise((resolve, reject) => {
        getSettingList().then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改按钮状态
    UpdateTruthValue({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateTruthValue(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateState({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateState(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default setting



// WEBPACK FOOTER //
// ./src/store/modules/setting.js